// @ts-strict-ignore
import { selectAppPlatform } from './../../../selectors/selectors';
import { selectAuthCredentials } from '../../../selectors/selectors';
import { useSelector } from 'react-redux';
import * as API from '../../../api';
import { RootState } from '../../../reducers/reducers';
import { QuickStartCIFilesResult } from '../../../types';
import { useState } from 'react';
import { isIosPlatform } from '../../../helpers';
import { GenerateQuickStartCIFilesRequest } from '../../../actions/appSettings';

export type GenerateQuickStartCIHookData = [
    QuickStartCIFilesResult | undefined,
    boolean,
    Error,
    (request: GenerateQuickStartCIFilesRequest) => Promise<void>,
];

export const useGenerateQuickStartCIFile: (orgId: string, appId: string) => GenerateQuickStartCIHookData = (
    orgId,
    appId,
) => {
    const [result, setResult] = useState<QuickStartCIFilesResult | undefined>(undefined);

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<Error | undefined>(undefined);
    const authCredentials = useSelector((state: RootState) => selectAuthCredentials(state));

    const platform = useSelector((state: RootState) => selectAppPlatform(state, appId));

    const startLoading = async (request: GenerateQuickStartCIFilesRequest) => {
        setIsLoading(true);
        setError(undefined);
        try {
            const apiCall =
                isIosPlatform(platform) ? API.generateQuickStartCIFilesiOS : API.generateQuickStartCIFilesAndroid;
            const apiResult = await apiCall(request, authCredentials);

            setResult(apiResult);
        } catch (error) {
            setError(error);
        } finally {
            setIsLoading(false);
        }
    };

    return [result, isLoading, error, startLoading];
};
